import { render, staticRenderFns } from "./PricingData.vue?vue&type=template&id=fd65a19e&scoped=true"
import script from "./PricingData.vue?vue&type=script&lang=js"
export * from "./PricingData.vue?vue&type=script&lang=js"
import style0 from "./PricingData.vue?vue&type=style&index=0&id=fd65a19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65a19e",
  null
  
)

export default component.exports